module.exports = __webpack_public_path__ + "files/e41b9493b9d172446ebf756c3e75ff6f.png";